export const HeartLargeIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 36 32"
    >
      <path
        fill="currentColor"
        d="M20.429 31.064a3.57 3.57 0 0 1-4.84-.018l-.199-.182C5.945 22.251-.227 16.611.006 9.576c.108-3.083 1.674-6.039 4.21-7.78C8.968-1.468 14.834.056 18 3.791c3.166-3.735 9.032-5.277 13.782-1.995 2.537 1.741 4.103 4.697 4.21 7.78.253 7.035-5.937 12.675-15.383 21.325z"
      />
    </svg>
  );
};
